export class companyTask {
    ID: string;
    CompletionDays: number;
    EscalationDays: string;
    salary: string;
    IsGlobal:boolean;
    Level2EscalationDays:number;
    MeetingType:string;
    MeetingTypeId:string
    ReminderDays:number;
    ReminderPeriod:number;
    ReminderPeriodLevel1:number;
    ReminderPeriodLevel2:number;
    SelectedTask : boolean;
    TaskDescription:string;
    TaskParticulars:string;
    TaskID:string; 
    ProcessID:string;
    TaskName:string;
    TriggerName:string;
    TriggerType:string;
    CompanyID:string;
}